import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setColorMode } from "../../actions/settings/SettingsAction";
import { ColorModeEnum, COLOR_MODE_KEY } from "../../constants/Enums/UiEnum";
import { LocalStorageService } from "../../services/LocalStorageService";
import { CustomisationHelper } from '../../services/helpers/CustomisationHelper'
import { BuilderInteractions } from '../../components/BuilderInteractions'

import Utils from "../../services/Utils";
import SiteEvent from "../../services/events/SiteEvent";
import { SportIntegration } from "../../services/helpers/sport/SportIntegration";


const ColorModeSwitch = ({ isVisible = true, labelText }) => {
    const dispatch = useDispatch()
    const uiSettingMode = useSelector((state) => state.settings.uiSettingMode);
    const enableSiteStylesForSport = useSelector((state) => state.settings?.sportSettings?.enableSiteStylesForSport);

    const storeData = LocalStorageService.get(COLOR_MODE_KEY)

    const initalVal = storeData?.mode || uiSettingMode

    const isMobile = Utils.isTablet()
    const valRef = useRef(null)

    const [checked, setChecked] = useState(+initalVal === ColorModeEnum.Dark)

    useEffect(() => {
        if(!LocalStorageService.get(COLOR_MODE_KEY)) {
            LocalStorageService.set(COLOR_MODE_KEY, { mode: initalVal, defaultValue: initalVal })
        }
    }, [])

    useEffect(() => {
        if (initalVal !== valRef.current) {
            setChecked(+(initalVal) === ColorModeEnum.Dark)
        }
        valRef.current = initalVal
    }, [initalVal])

    const handleChange = Utils.debounceForToggle((e) => {

        const mode = e.target.checked ? ColorModeEnum.Dark : ColorModeEnum.Light

        SiteEvent.dispatch({
            target: `${Object.keys(ColorModeEnum).find(key => ColorModeEnum[key] === mode)}Mode`,
            rootTarget: 'header',
            type: e?.type,
            data: {
                theme: `${Object.keys(ColorModeEnum).find(key => ColorModeEnum[key] !== mode)}_to_${Object.keys(ColorModeEnum).find(key => ColorModeEnum[key] === mode)}`
            }
        })

        LocalStorageService.set(COLOR_MODE_KEY, { mode, defaultValue: (storeData?.defaultValue || uiSettingMode) });
        dispatch(setColorMode(`${mode}`));

        //What a shame )))
        setTimeout(function () {
            const cssVariables = CustomisationHelper.getCustomCssVars(false);
            let data = { payload: cssVariables };
            if (enableSiteStylesForSport) {
                BuilderInteractions.handleColorChange(data, false);
            } else {
                SportIntegration.changeColorMode();
            }

        }, 50);


    }, 300); // 300ms debounce time

    const desktopHtml = (<div className="color-mode">
        <input
            defaultChecked={checked} onChange={handleChange} type="checkbox" id="all-color-toggle" />
        <label htmlFor="all-color-toggle">
            <span className="digi_icon-dark"></span>
            <span className="digi_icon-light"></span>
        </label>
    </div>)

    const mobileHtml = (<div key={checked} className="mb-color-mode">
        {labelText && <div className="mb-mode-text">
            {labelText}
        </div>}
        <div className="color-mode">
            <input defaultChecked={checked} onChange={handleChange} type="checkbox" id="mb-color-toggle" />
            <label htmlFor="mb-color-toggle">
                <span className="digi_icon-dark"></span>
                <span className="digi_icon-light"></span>
            </label>
        </div>
    </div>)
    return isVisible && uiSettingMode ? (isMobile ? mobileHtml : desktopHtml) : null

}

export default ColorModeSwitch